import React from 'react';

const Hero = ({ data, onNavigate }) => {
    const handleScheduleClick = () => {
        if (onNavigate) {
            onNavigate('contact');
        }
    };

    const handleLearnMoreClick = () => {
        if (onNavigate) {
            onNavigate('about');
        }
    };

    return (
        <section className="relative h-screen min-h-[600px] max-h-[800px] overflow-hidden bg-gradient-to-br from-stone-100 to-amber-100/40">
            {/* Background Image */}
            {data.backgroundImage && (
                <div className="absolute inset-0 h-full">
                    <img
                        src={data.backgroundImage}
                        alt="Hero background"
                        className="w-full h-full object-cover"
                    />
                    {/* Light overlay */}
                    <div className="absolute inset-0 bg-stone-400 bg-opacity-20"></div>
                </div>
            )}

            {/* Gradient overlay for text readability */}
            <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-transparent"></div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
                <div className="h-full flex items-center">
                    <div className="lg:w-2/3 xl:w-1/2">
                        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-tight mb-6 drop-shadow-2xl">
                            {data.title}
                        </h1>

                        <p className="text-lg sm:text-xl text-white/95 mb-8 leading-relaxed max-w-2xl drop-shadow-lg">
                            {data.subtitle}
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={handleScheduleClick}
                                className="bg-white text-stone-800 px-8 py-4 rounded-lg font-medium hover:bg-stone-100 transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
                            >
                                {data.buttonText}
                            </button>

                            <button
                                onClick={handleLearnMoreClick}
                                className="border-2 border-white/80 text-white px-8 py-4 rounded-lg font-medium hover:bg-white/10 hover:border-white transition-all duration-200 backdrop-blur-sm"
                            >
                                Learn More
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;